"use client"
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import CategoryIcon from '@mui/icons-material/Category';
import TtkList from './TtkList';
const BridalmakeupTTK = ({ data }) => {
    return (
        <>

            <div className="row">
                <div className="col-md-12">
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p> <WorkspacePremiumIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Working Since :</b>&nbsp;<TtkList data={data?.workingSince} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Bridal Makeup Price :</b>&nbsp;<span>{data?.bridalMakeupPrice}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting AirBrush Starting Bridal Makeup Price :</b>&nbsp;<span>{data?.airBrushBridalMakeupPrice}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Party Makeup for Family Per Person :</b>&nbsp;<span>{data?.partyMakeupPrice}</span></p>
                        </div>

                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-3'>
                            <p ><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting OutStation Makeup Charges :</b>&nbsp;<span>{data?.outStationMakeupCharges}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p ><MonetizationOnIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Starting Engagement Makeup Price :</b>&nbsp;<span>{data?.engagementMakeupPrice}</span></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <CategoryIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Product Used 
                                :</b>&nbsp;<TtkList data={data?.productUsed} /></p>
                        </div>
                        <div className='col-md-3'>
                            <p> <DesignServicesIcon sx={{ fontSize: 20 }} style={{ color: "black" }} />&nbsp;<b>Service Provided Cities :</b>&nbsp;<TtkList data={data?.sericeProvided} /></p>
                        </div>
                    </div>
                    <div className='row mb-2'>
                    </div>
                </div>
            </div>

        </>
    )
}

export default BridalmakeupTTK